// import Numeral from 'numeral';
import moment from 'moment-timezone';
import Vue from 'vue';
import KMLHelper from './KMLHelper';

Number.prototype.leftZeroPad = function(numZeros) {
	var n = Math.abs(this);
	var zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
	var zeroString = Math.pow(10, zeros).toString().substr(1);
	if (this < 0) {
		zeroString = '-' + zeroString;
	}

	return zeroString + n;
}


Number.prototype.isNumber = function() {
	return !isNaN(parseFloat(this)) && isFinite(this);
}

String.prototype.formatUnicorn = function() {
	"use strict";
	var str = this.toString();
	if (arguments.length) {
		var t = typeof arguments[0];
		var key;
		var args = ("string" === t || "number" === t) ?
			Array.prototype.slice.call(arguments) :
			arguments[0];

		for (key in args) {
			str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
		}
	}

	return str;
}



String.prototype.isNumber = function() {
	return !isNaN(parseFloat(this)) && isFinite(this);
}

String.prototype.toTitleCase = function() {
	var i, j, str, lowers, uppers;
	str = this.replace(/([^\W_]+[^\s-]*) */g, function(txt) {
		txt = txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();

		// Deal with names that start with Mc
		if (txt.charAt(0) == "M" && txt.charAt(1) == "c") {
			txt = txt.charAt(0) + txt.charAt(1) + txt.charAt(2).toUpperCase() + txt.substr(3);
		}

		return txt;
	});

	// Certain minor words should be left lowercase unless
	// they are the first or last words in the string
	lowers = ['A', 'An', 'The', 'And', 'But', 'Or', 'For', 'Nor', 'As', 'At',
  'By', 'For', 'From', 'In', 'Into', 'Near', 'Of', 'On', 'Onto', 'To', 'With', 'Du'];
	for (i = 0, j = lowers.length; i < j; i++)
		str = str.replace(new RegExp('\\s' + lowers[i] + '\\s', 'g'),
			function(txt) {
				return txt.toLowerCase();
			});

	// Certain words such as initialisms or acronyms should be left uppercase
	uppers = ['Id', 'Tv', 'Ii', 'Iii', 'Iv', 'V', 'Ix'];
	for (i = 0, j = uppers.length; i < j; i++)
		str = str.replace(new RegExp('\\b' + uppers[i] + '\\b', 'g'),
			uppers[i].toUpperCase());

	// 'Macgregor'
	str = str.replace(new RegExp('Macgregor', 'g'), 'MacGregor');

	return str;
}

export default class Format {

	static createDataTree = dataset => {
		let hashTable = Object.create(null)
		dataset.forEach(aData => hashTable[aData.id] = {...aData,
			children: []
		})
		let dataTree = []
		dataset.forEach(aData => {
			if (aData.parentId) hashTable[aData.parentId].children.push(hashTable[aData.id])
			else dataTree.push(hashTable[aData.id])
		})
		return dataTree
	}


	static TryParseInt(str) {
		var retValue = null;
		if (str && !isNaN(str) && /^\d+$/g.test(str)) {
			retValue = parseInt(str);
		}
		return retValue;
	}

	static address(value) {
		if (value) {
			return value.toTitleCase();
		} else {
			return value;
		}
	}
	static name(value) {
		if (value) {
			return value.toTitleCase();
		}
		return value;
	}


	/**
	 * Function to sort alphabetically an array of objects by some specific key.
	 *
	 * @param {String} property Key of the object to sort.
	 */
	static dynamicSort(property) {
		var sortOrder = 1;

		if (property[0] === "-") {
			sortOrder = -1;
			property = property.substr(1);
		}

		return function(a, b) {
			if (sortOrder == -1) {
				return b[property].localeCompare(a[property]);
			} else {
				return a[property].localeCompare(b[property]);
			}
		}
	}



	static fixStreetSuffix(value) {
		// TODO: Fix all of the street suffixes...
		if (value != null) {
			value = value.replace(new RegExp(" Av$", "gm"), " Avenue");
			value = value.replace(new RegExp(" St$", "gm"), " Street");
			value = value.replace(new RegExp(" Rd$", "gm"), " Road");
		}
		return value;

	}

	static fileSize(bytes, decimalPoint) {
		if (bytes == 0) return '0 Bytes';
		var k = 1000,
			dm = decimalPoint || 2,
			sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}
	static pipesToFlatTree(str) {
		if (str) {
			let pipes = str.split("|");
			let newStr = "";
			let x = 0;
			let count = 0;
			let firstX = -1;
			let start = "";
			let end = "";
			start = "<span class='flat-tree first'>";
			end = "</span>";
			for (x = 0; x < pipes.length; x++) {
				if (pipes[x] != "") {
					if (firstX < 0) {
						firstX = x;
					}
					newStr += start + pipes[x] + end;
					start = "<span class='flat-tree'>";
					end = "</span>";
					count++;
				}
			}
			if (count == 1) {
				// only one item change first to only-one
				newStr = "<span class='flat-tree only-one'>";
				newStr += pipes[firstX];
				newStr += "</span>";
			}
			return newStr;
		}
		return null;
	}


	static pipesToArrows(str) {
		let pipes = str.split("|");
		let newStr = "";
		let x = 0;
		let arrow = "";
		for (x = 0; x < pipes.length; x++) {
			if (pipes[x] != "") {
				newStr += arrow + pipes[x];
				arrow = " > ";
			}
		}
		return newStr;
	}

	static postalCode(value) {
		if (value) {
			var parts = value.match(/^([A-Za-z][0-9][A-Za-z])\s*([0-9][A-Za-z][0-9])$/);
			if (parts) {
				parts.shift();
				value = parts.join(' ').toUpperCase();
			}
			return value.toUpperCase();
		} else {
			return value;
		}
	}

	static city(value) {
		if (value) {
			return value.toTitleCase();
		}
		return value;
	}

	static phone(value) {
		var parts = null;
		if (value) {
			value = value.replace(new RegExp('[^0-9]', 'g'), "");

			if (value.length == 11) {
				parts = value.match(/^([0-9])([0-9][0-9][0-9])([0-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/);
				if (parts) {
					value = "+" + parts[1] + "(" + parts[2] + ") " + parts[3] + "-" + parts[4];
				}
			}

			if (value.length == 10) {
				parts = value.match(/^([0-9][0-9][0-9])([0-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/);
				if (parts) {
					value = "(" + parts[1] + ") " + parts[2] + "-" + parts[3];
				}
			}
			if (value.length == 7) {
				parts = value.match(/^([0-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/);
				if (parts) {
					value = parts[1] + "-" + parts[2];
				}
			}
			return value;
		} else {
			return value;
		}
	}

	static makeId(value) {
		value = value.replace(new RegExp('[^0-9a-zA-Z]', 'g'), "");
		return value;
	}

	static hrefPhone(value) {
		if (value) {
			value = value.replace(new RegExp('[^0-9]', 'g'), "");
			if (value) {
				return "tel:" + value;
			}
		}
		return null;
	}

	static hrefEmail(value) {
		if (value) {
			value = value.toLowerCase();
			if (value) {
				return "mailto:" + value;
			}
		}
		return null;
	}



	static email(value) {
		if (value) {
			return value.toLowerCase();
		} else {
			return value;
		}
	}

	static searchByGroupedId(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].options) {
				for (let ii = 0; ii < iArray[i].options.length; ii++) {
					if (iArray[i].options[ii].id === nameKey) {
						return iArray[i].options[ii]
					}
				}
			}
		}
	}

	static searchById(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].id === nameKey) {
				return iArray[i]
			}
		}
	}

	static searchByKeyInArray(searchValue, key, array) {
		for (let i = 0; i < array.length; i++) {
			if (eval(`array[i].${key}`) === searchValue) {
				return array[i]
			}
		}
	}
	static capitalize(str = '') {
		return str.toLowerCase().split(' ').map(function(word) {
			return (word.charAt(0).toUpperCase() + word.slice(1));
		}).join(' ');
	}
	static capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	static padLeft(str = '', pad, chr = '') {
		if (typeof str != 'string') {
			str = str.toString()
		}
		pad = chr.repeat(pad)
		return pad.substring(0, pad.length - str.length) + str
	}

	static diffYMDHMS(date1Value, date2Value) {
		let date1 = Format.fromUtc(date1Value);
		let date2 = Format.fromUtc(date2Value);

		let years = Math.abs(date1.diff(date2, 'year'));
		date2.add(years, 'years');

		let months = Math.abs(date1.diff(date2, 'months'));
		date2.add(months, 'months');

		let days = Math.abs(date1.diff(date2, 'days'));
		date2.add(days, 'days');

		let hours = Math.abs(date1.diff(date2, 'hours'));
		date2.add(hours, 'hours');

		let minutes = Math.abs(date1.diff(date2, 'minutes'));
		date2.add(minutes, 'minutes');

		let seconds = Math.abs(date1.diff(date2, 'seconds'));

		return {
			years,
			months,
			days,
			hours,
			minutes,
			seconds
		};
	}

	static addDays(date, days) {
			date = date == null
					? moment.tz(Format.TIMEZONE)
					: Format.fromUtc(date);

			return date.add(days, 'days');
	}

	// static addDays(date, days) {
	// 	if (date == null) {
	// 		date = moment(); // use a clone
	// 	} else {
	// 		date = moment(date); // use a clone
	// 	}
	// 	while (days > 0) {
	// 		date = date.add(1, 'days');
	// 		days -= 1;
	// 	}
	// 	return date;
	// }


	static addWeekdays(date, days) {
			date = date == null
					? moment.tz(Format.TIMEZONE)
					: Format.fromUtc(date);

		while (days > 0) {
					date.add(1, 'days');

			if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
							days--;
			}
		}
		return date;
	}

	static subtractWeekdays(date, days) {
			date = date == null
					? moment.tz(Format.TIMEZONE)
					: Format.fromUtc(date);

		while (days > 0) {
					date.subtract(1, 'days');

			if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
							days--;
			}
		}
		return date;
	}

	static subtractDays(date, days) {
			date = date == null
					? moment.tz(Format.TIMEZONE)
					: Format.fromUtc(date);

			return date.subtract(days, 'days');
	}

	// static subtractDays(date, days) {
	// 	if (date == null) {
	// 		date = moment(); // use a clone
	// 	} else {
	// 		date = moment(date); // use a clone
	// 	}
	// 	while (days > 0) {
	// 		date = date.subtract(1, 'days');
	// 		days -= 1;
	// 	}
	// 	return date;
	// }




	static getApiUrl(url) {
		return Vue.prototype.$store.state.apiUrl + url + "?r=" + Math.round(Math.random() * Math.pow(10, 6));
	}


	static diffYMDHMSAgo(date1Value, date2Value) {
		let date1 = Format.fromUtc(date1Value);
		let date2 = Format.fromUtc(date2Value);


		let years = date1.diff(date2, 'year');
		date2.add(years, 'years');

		let months = date1.diff(date2, 'months');
		date2.add(months, 'months');

		let days = date1.diff(date2, 'days');
		date2.add(days, 'days');

		let hours = date1.diff(date2, 'hours');
		date2.add(hours, 'hours');

		let minutes = date1.diff(date2, 'minutes');
		date2.add(minutes, 'minutes');

		let seconds = date1.diff(date2, 'seconds');

		return {
			years,
			months,
			days,
			hours,
			minutes,
			seconds
		};
	}


	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	}


	static decodePolyline(encoded) {
		if (!encoded) {
			return [];
		}
		var poly = [];
		var index = 0,
			len = encoded.length;
		var lat = 0,
			lng = 0;

		while (index < len) {
			var b, shift = 0,
				result = 0;

			do {
				b = encoded.charCodeAt(index++) - 63;
				result = result | ((b & 0x1f) << shift);
				shift += 5;
			} while (b >= 0x20);

			var dlat = (result & 1) != 0 ? ~(result >> 1) : (result >> 1);
			lat += dlat;

			shift = 0;
			result = 0;

			do {
				b = encoded.charCodeAt(index++) - 63;
				result = result | ((b & 0x1f) << shift);
				shift += 5;
			} while (b >= 0x20);

			var dlng = (result & 1) != 0 ? ~(result >> 1) : (result >> 1);
			lng += dlng;

			var p = {
				lat: lat / 1e5,
				lng: lng / 1e5,
			};
			poly.push(p);
		}
		return poly;
	}

	static getKmlCoords(block) {
		var coords = [];
		var myParser = new Vue.prototype.$geoXML3.parser({
			map: null,
			afterParse: function(doc) {
				let xx = 0;
				let zz = 0;
				for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
					for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
						// coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
						coords.push({
							lat: doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(),
							lng: doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()
						});
					}
				}
			}
		});

		let kmlString = "";
		if (block.kml != "") {
			let color = "7fff0000";
			kmlString += KMLHelper.createPlaceMarkFromGeometry(block.id, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
			kmlString = KMLHelper.finalizeKml(kmlString);
			myParser.parseKmlString(kmlString);
			return coords;
		}
	}



	// getMidpoint: function(points, midpointDistance) {
	// 	var tempDistance = midpointDistance;
	// 	var midpointLatLng;

	// 	// We go through each segment of the line
	// 	for (var i = 0; i < points.length - 1; i++) {
	// 		var segment = points.slice(i, i + 2);
	// 		var length = google.maps.geometry.spherical.computeLength(segment);
	// 		tempDistance = tempDistance - length;

	// 		// If we're at zero or below, we've found the line where our midpoint exists
	// 		if (tempDistance <= 0) {
	// 			// We've gone past the midpoint so we need to back up.
	// 			var midpointLength = tempDistance + length;

	// 			// The proportion of the current segment where our midpoint exists
	// 			var percentage = midpointLength / length;

	// 			midpointLatLng = google.maps.geometry.spherical.interpolate(segment[0], segment[1], percentage);
	// 			break;
	// 		}
	// 	}

	// 	if (typeof midpointLatLng === 'undefined') {
	// 		// we don't have a midpoint for this polyline, something went very wrong
	// 		return false;
	// 	} else {
	// 		return midpointLatLng;
	// 	}
	// }




	//
	// Calculate the distance between two points
	//
	static distance(a, b) {
		var dx = a.lat() - b.lat();
		var dy = a.lng() - b.lng();
		return Math.sqrt(dx * dx + dy * dy);
	}

	static streetSearch(affectedStreet, fromStreet) {
		if (affectedStreet.substr(-3) == " Av" || affectedStreet.substr(-3) == " av") {
			affectedStreet += "e";
		}
		if (affectedStreet.indexOf(" Bv") > 0) {
			affectedStreet = affectedStreet.replace(" Bv", " Blvd");
		}

		if (fromStreet.substr(-3) == " Av" || fromStreet.substr(-3) == " av") {
			fromStreet += "e";
		}
		if (fromStreet.indexOf(" Bv") > 0) {
			fromStreet = fromStreet.replace(" Bv", " Blvd");
		}
		return affectedStreet + " and " + fromStreet;
	}

	//
	// Given a line between point1 and point2 return a point that
	// is distance away from point1
	//
	static lineInterpolate(point1, point2, distance) {
		var xabs = Math.abs(point1.lat() - point2.lat());
		var yabs = Math.abs(point1.lng() - point2.lng());
		var xdiff = point2.lat() - point1.lat();
		var ydiff = point2.lng() - point1.lng();

		var length = Math.sqrt((Math.pow(xabs, 2) + Math.pow(yabs, 2)));
		var steps = length / distance;
		var xstep = xdiff / steps;
		var ystep = ydiff / steps;

		return {
			lat: point1.lat() + xstep,
			lng: point1.lng() + ystep
		};
	}

	//
	// Return the point that is the midpoint for the line
	//
	static lineMidpoint(lineSegments) {
		//
		// Sum up the total distance of the line
		//
		var TotalDistance = 0;
		for (var i = 0; i < lineSegments.length - 1; i += 1) {
			TotalDistance += this.distance(lineSegments[i], lineSegments[i + 1]);
		}
		// console.log("TotalDistance:" + TotalDistance);

		//
		// Find the middle segemnt of the line
		//
		var DistanceSoFar = 0;
		for (var i = 0; i < lineSegments.length - 1; i += 1) {  // eslint-disable-line
			//
			// If this linesegment puts us past the middle then this
			// is the segment in which the midpoint appears
			//
			if (DistanceSoFar + this.distance(lineSegments[i], lineSegments[i + 1]) > TotalDistance / 2) {
				//
				// Figure out how far to the midpoint
				//
				var DistanceToMidpoint = TotalDistance / 2 - DistanceSoFar;

				//
				// Given the start/end of a line and a distance return the point
				// on the line the specified distance away
				//
				return this.lineInterpolate(lineSegments[i], lineSegments[i + 1], DistanceToMidpoint);
			}

			DistanceSoFar += this.distance(lineSegments[i], lineSegments[i + 1]);
		}

		//
		// Can happen when the line is of zero length... so just return the first segment
		//
		return lineSegments[0];
	}



	static TIMEZONE = 'America/Winnipeg';

	/**
	 * Convert an API UTC timestamp into a Winnipeg Moment.
	 */
	static fromUtc(value) {
			if (value == null || value === '') return null;

			if (moment.isMoment(value)) {
					return value.clone().tz(Format.TIMEZONE);
			}

			return moment.utc(value).tz(Format.TIMEZONE);
	}



	/**
	 * Convert an API UTC timestamp into a Date suitable
	 * for the existing Vue date/time picker.
	 *
	 * The Date contains Winnipeg wall-clock components.
	 * Do not serialize it directly as UTC.
	 */
	static utcToPickerDate(value) {
			if (value == null || value === '') return null;

			const local = Format.fromUtc(value);

			return new Date(
					local.year(),
					local.month(),
					local.date(),
					local.hour(),
					local.minute(),
					local.second(),
					local.millisecond()
			);
	}

	/**
	 * Interpret a date picker's selected wall-clock time
	 * as Winnipeg time, then convert it to UTC for the API.
	 */
	static pickerDateToUtc(value) {
			if (value == null) return null;
			if (typeof value == "object") {

				const local = moment.tz({
						year: value.getFullYear(),
						month: value.getMonth(),
						day: value.getDate(),
						hour: value.getHours(),
						minute: value.getMinutes(),
						second: value.getSeconds(),
						millisecond: value.getMilliseconds()
				}, Format.TIMEZONE);
				return local.utc().format();

			} else {

				return value;
			}


	}

	/**
	 * Format an API UTC timestamp in local time (forced to Winnipeg)
	 */
	static toLocalDateTime(value, format = 'MM/DD/YYYY H:mm') {
			if (value == null || value === '') return null;

			return Format.fromUtc(value).format(format);
	}

	static mergeUtcDateTime(date, time) {
			if (!time) return date || null;
			if (!date) return moment.utc(time).format();

			const localDate = Format.fromUtc(date);
			const localTime = Format.fromUtc(time);

			return moment.tz({
					year: localDate.year(),
					month: localDate.month(),
					day: localDate.date(),
					hour: localTime.hour(),
					minute: localTime.minute(),
					second: 0,
					millisecond: 0
			}, Format.TIMEZONE).utc().format();
	}


	static mergePickerDate(utcValue, pickerDate) {
			if (!pickerDate) return null;

			const existing = utcValue
					? Format.fromUtc(utcValue)
					: moment.tz(Format.TIMEZONE).startOf('day');

			return moment.tz({
					year: pickerDate.getFullYear(),
					month: pickerDate.getMonth(),
					day: pickerDate.getDate(),
					hour: existing.hour(),
					minute: existing.minute(),
					second: existing.second(),
					millisecond: existing.millisecond()
			}, Format.TIMEZONE).utc().format();
	}


	static startOfLocalDay(value = null) {
			return (value == null
					? moment.tz(Format.TIMEZONE)
					: Format.fromUtc(value)
			).startOf('day');
	}

	static endOfLocalDay(value = null) {
			return (value == null
					? moment.tz(Format.TIMEZONE)
					: Format.fromUtc(value)
			).endOf('day');
	}

	static formatPickerDateRange(startDate, endDate, format = 'MM/DD/YYYY') {
			if (!startDate || !endDate) return '';

			const toLocal = (date) => moment.tz({
					year: date.getFullYear(),
					month: date.getMonth(),
					day: date.getDate()
			}, Format.TIMEZONE);

			console.log("formatPickerDateRange");
			console.log(`${toLocal(startDate).format(format)} - ${toLocal(endDate).format(format)}`);

			return `${toLocal(startDate).format(format)} - ${toLocal(endDate).format(format)}`;
	}


static getLocalDatePickerRanges() {
    const today = moment.tz(Format.TIMEZONE).startOf('day');

    // Convert a Winnipeg calendar date into a Date object
    // suitable for the date-range picker.
    const toPickerDate = (local) => new Date(
        local.year(),
        local.month(),
        local.date()
    );

    const range = (start, end) => [
        toPickerDate(start),
        toPickerDate(end)
    ];

    return {
        'No Date': [null, null],

        'Yesterday': range(
            today.clone().subtract(1, 'day'),
            today.clone().subtract(1, 'day')
        ),

        'Last week': range(
            today.clone().subtract(1, 'week').startOf('week'),
            today.clone().subtract(1, 'week').endOf('week')
        ),

        'Last two week': range(
            today.clone().subtract(2, 'weeks').startOf('week'),
            today.clone().subtract(1, 'week').endOf('week')
        ),

        'Today': range(today, today),

        'Today +- 3 Business': range(
            Format.subtractWeekdays(today.clone(), 3),
            Format.addWeekdays(today.clone(), 3)
        ),

        'This week': range(
            today.clone().startOf('week'),
            today.clone().endOf('week')
        ),

        'Next week': range(
            today.clone().add(1, 'week').startOf('week'),
            today.clone().add(1, 'week').endOf('week')
        ),

        'Next two weeks': range(
            today.clone().add(1, 'week').startOf('week'),
            today.clone().add(2, 'weeks').endOf('week')
        )
    };
}


	static OLD_getLocalDatePickerRanges() {
			const today = moment.tz(Format.TIMEZONE).startOf('day');

			const toPickerDate = (local) => new Date(
					local.year(),
					local.month(),
					local.date()
			);

			const range = (start, end) => [
					toPickerDate(start),
					toPickerDate(end)
			];

			return {
					'No Date': [null, null],

					'Yesterday': range(
							today.clone().subtract(1, 'day'),
							today.clone().subtract(1, 'day')
					),

					'Last week': range(
							today.clone().subtract(1, 'week').startOf('week'),
							today.clone().subtract(1, 'week').endOf('week')
					),

					'Last two weeks': range(
							today.clone().subtract(2, 'weeks').startOf('week'),
							today.clone().subtract(1, 'week').endOf('week')
					),

					'Today': range(today, today),

					'This week': range(
							today.clone().startOf('week'),
							today.clone().endOf('week')
					),

					'Next week': range(
							today.clone().add(1, 'week').startOf('week'),
							today.clone().add(1, 'week').endOf('week')
					),

					'Next two weeks': range(
							today.clone().add(1, 'week').startOf('week'),
							today.clone().add(2, 'weeks').endOf('week')
					)
			};
	}



}